import React from 'react';
import Footer from '../Home/Footer';
import Hero from './Hero.js';
import Header from '../Home/Header';
import Schedule from './Schedule.js';
import Summarize from './Summarize.js';
import ChatBot from './ChatBot.js';
import WhyConvoMarketing from './WhyConvoMarketing.js';
import WhyHumanFirstSection from './WhyHumanFirst.js';
import LiveChat from './LiveChat.js';
import styled from 'styled-components';
import { Helmet } from "react-helmet";

import rightLine1 from 'resources/img/rightLine1.svg';

const RightLine1 = styled.img`
    position: absolute;
    top: 30vh;
    width: 88%;
    right: -30rem;
    @media only screen and (max-width: ${p => p.theme.breakpoints.md - 1}px) {
        display: none;
    }
`;

const HeaderWrapper = styled.div`
    min-height: 6rem;
    background: ${p => p.theme.palette.blue.one};
`;

const WHFContainer = styled.div`
    position: relative;
    overflow: hidden;
`;



const WhyHumanFirst = props => {
    return (
        <WHFContainer>
            <Helmet>
                <meta charSet="utf-8" />
                <meta name="description" content="Learn how Insent uses machine learning and AI to create a more personalized  customer experience. We call it human first, and it’s here to help you get more qualified leads. " />
                <meta name="keywords" content="machine learning and ai, Audience segmentation , Qualified leads, digital customer experience" />
                <title>Why Human First? Machine Learning and AI | Insent.ai Bot</title>
            </Helmet>
            <RightLine1 src={rightLine1} />
            <HeaderWrapper>
                <Header />
            </HeaderWrapper>
            <Hero />
            <WhyConvoMarketing />
            <WhyHumanFirstSection />
            <LiveChat />
            <ChatBot />
            <Summarize />
            <Schedule />
            <Footer />
        </WHFContainer>
    );
};

WhyHumanFirst.propTypes = {};

export default WhyHumanFirst;